import React from "react";
import QRCode from "react-qr-code";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Paper
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { useSelector } from "react-redux";

function QrGenerator({ open, onClose, jobId, clientId, workPackageData }) {
  // Create the QR code value
  const qrValue = JSON.stringify({
    jobId: jobId || 0,
    clientId: clientId || 0,
    workPackageId: workPackageData?.id || 0
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxHeight: "90vh"
        }
      }}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          pb: 1
        }}>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pb: 2, textAlign: "center" }}>
        <Box sx={{ mb: 3 }}>
          <Paper
            elevation={2}
            sx={{
              display: "inline-block",
              padding: "20px",
              borderRadius: "12px",
              backgroundColor: "#fff"
            }}>
            <QRCode
              id="qr-code-svg"
              value={qrValue}
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              viewBox="0 0 256 256"
            />
          </Paper>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default QrGenerator;
